import { Footer as SharedFooter } from '@elka/ui';
import packageJson from '../../../package.json';

export function Footer() {
  return <SharedFooter appTitle="מערכת ניהול אלקה" version={packageJson.version} />;
}
